import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor, DropTarget, DropTargetConnector, DropTargetMonitor } from 'react-dnd';
import DragTypes from '../../../../infrastructure/DragTypes';
import { isRightPageOnlyPlaceholderType } from '../../../../infrastructure/placeholderTypes';

export interface IDragThumbnailProps {
  connectDragSource?: Function;
  connectDropTarget?: Function;
  item: any;
  index: number;
  canDrag: boolean;
  isOver: boolean;
  canDrop: boolean;
  isDragging: boolean;
  type: number;
  position: string;
  moveThumbnail?(dragIndex: number, hoverIndex: number): void;
}

const thumbnailSource = {
  beginDrag(props: IDragThumbnailProps) {
    return {
      type: props.type,
      index: props.index,
    };
  },
  canDrag(props: IDragThumbnailProps) {
    return props.canDrag;
  },
};

const thumbnailTarget = {

  hover(props: IDragThumbnailProps, monitor: any) {
    const item = monitor.getItem();
    const dragIndex = item.index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex || hoverIndex === 0 || props.canDrag === false) {
      return;
    }

    if (isRightPageOnlyPlaceholderType(item.type) && props.position === 'left') {
      return;
    }

    if (props.moveThumbnail != undefined) {
      props.moveThumbnail(dragIndex, hoverIndex);
    }
    item.index = hoverIndex;
  },

  canDrop(props: IDragThumbnailProps, monitor: any) {
    const item = monitor.getItem();

    if (props.canDrag === false) {
      return false;
    }

    if (isRightPageOnlyPlaceholderType(item.type) && props.position === 'left') {
      return false;
    }
    
    return true;
  },

};

function collectDroppedItem(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
  };
}

function collectDraggedItem(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

@DragSource(DragTypes.THUMBNAIL, thumbnailSource, collectDraggedItem)
@DropTarget(DragTypes.THUMBNAIL, thumbnailTarget, collectDroppedItem)
export default class DragThumbnail extends React.Component<IDragThumbnailProps> {
  constructor(props: IDragThumbnailProps) {
    super(props);
  }

  render() {
    const {
      isOver,
      canDrop,
      item,
    } = this.props;

    const isActive = isOver && canDrop;
    const notDrop = isOver && !canDrop;
    let className = '';
    if (isActive) {
      className = 'is-draggin';
    } else if (notDrop) {
      className = 'is-error';
    }

    if (this.props.connectDragSource && this.props.connectDropTarget) {
      return this.props.connectDragSource(
        this.props.connectDropTarget(<div className={className}>{item}</div>),
      );
    }

    return (<div className={className}>{item}</div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/DragThumbnail.tsx